<template>
  <v-container class="app">
    <v-col cols="12">
      <v-row>
        <v-col cols="12">
          <v-form ref=" turtle">
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="record.turtle_code"
                  :items="refTables['ref_turtle_species']"
                  item-text="title"
                  item-value="code"
                  filled
                  label="Turtle type"
                  clearable
                  @input="submit"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="record.observation_ts"
                  filled
                  label="Observation Time:"
                  required="true"
                  :rules="required"
                  clearable
                  @input="submit"
                  :visible="true"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3">
                <v-checkbox
                  v-model="record.tracks"
                  filled
                  label="Tracks"
                  clearable
                  @input="submit"
                  true-value="true"
                  false-value="false"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  v-model="record.nest"
                  filled
                  label="Nest"
                  clearable
                  @input="submit"
                  :visible="true"
                  true-value="true"
                  false-value="false"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  v-model="record.animal"
                  filled
                  label="Animal"
                  clearable
                  @input="submit"
                  :visible="true"
                  true-value="true"
                  false-value="false"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  v-model="record.false_crawl"
                  :stringValue="record.false_crawl"
                  filled
                  label="False Crawl"
                  clearable
                  @input="submit"
                  :visible="true"
                  true-value="true"
                  false-value="false"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="record.turtle_location"
                  filled
                  label="Location Description:"
                  clearable
                  @input="submit"
                  :visible="true"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="record.distance_water"
                  filled
                  label="Distance From Water (m):"
                  type="Number"
                  clearable
                  @input="submit"
                  :visible="true"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="record.comment"
                  filled
                  label="Comment:"
                  clearable
                  @input="submit"
                  :visible="true"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { support } from "search-observe-app";
export default {
  name: "Turtle-Form",
  props: {
    photo_records: Array,
    selected_record: Object,
    notSearch: Boolean,
  },
  components: {},
  data() {
    return {
      handler: {
        submit: this.submit,
      },
      required: [(v) => !!v || "Required"],
      tableName: "survey_ turtle",
      record: this.selected_record,
    };
  },
  mounted() {
    this.$watch(
      "selected_record",
      () => {
        this.record = this.selected_record;
      },
      { deep: true }
    );
  },
  methods: {
    submit() {
      let records = support.forceFieldTypes(support.data.SURVEYPRIMARY, [
        this.record,
      ]);
      console.log(records);
      support.saveRecord(support.data.SURVEYPRIMARY, records[0]);
    },
    onDateTimeSet(value, parameter) {
      this.record[parameter] = support.getLocalTimestamp(new Date(value));
    },
  },
  computed: {
    refTables() {
      return this.$store.getters["shared/refTables"];
    },
  },
};
</script>
